import {
  AddCardOutlined,
  BedOutlined,
  PaymentsRounded,
  PersonPinCircleRounded,
  ShoppingCartOutlined,
} from "@mui/icons-material";

interface Service {
  icon: JSX.Element;
  /** i18n-ключ заголовка (в неймспейсе `home`). */
  titleKey: string;
  /** i18n-ключ подписи (в неймспейсе `home`); может быть пустым. */
  descriptionKey?: string;
  /**
   * i18n-ключ текста, который будет подставлен в ссылку в TG-менеджера
   * (`?text=…`). Мы кодируем результат в encodeURIComponent на клиенте.
   */
  messageKey: string;
  managerUsername?: string;
  soon?: boolean;
}

export const services: Service[] = [
  {
    icon: <PaymentsRounded sx={{ width: "20px" }} color="primary" />,
    titleKey: "additional_services.items.invoice.title",
    descriptionKey: "additional_services.items.invoice.description",
    messageKey: "additional_services.items.invoice.message",
  },
  {
    icon: <PersonPinCircleRounded sx={{ width: "20px" }} color="primary" />,
    titleKey: "additional_services.items.cash.title",
    descriptionKey: "additional_services.items.cash.description",
    messageKey: "additional_services.items.cash.message",
  },
  {
    icon: <BedOutlined sx={{ width: "20px" }} color="primary" />,
    titleKey: "additional_services.items.hotels.title",
    messageKey: "additional_services.items.hotels.message",
  },
  {
    icon: <ShoppingCartOutlined sx={{ width: "20px" }} color="primary" />,
    titleKey: "additional_services.items.online.title",
    messageKey: "additional_services.items.online.message",
  },
  {
    icon: <AddCardOutlined sx={{ width: "20px" }} color="primary" />,
    titleKey: "additional_services.items.foreign_card.title",
    messageKey: "additional_services.items.foreign_card.message",
  },
];
